import React from 'react';
import { smoothScroll } from '../utils/scroll';
import './NavMenu.css';

interface MenuItem {
  label: string;
  href: string;
}

const NavMenu: React.FC = () => {
  const menuItems: MenuItem[] = [
    { label: 'Home', href: '#home' },
    // { label: 'Eventi', href: '#eventi' },
    { label: 'Chi Siamo', href: '#chi-siamo' },
    // { label: 'Blog', href: '#blog' },
    // { label: 'Membership', href: '#membership' },
    { label: 'Contattaci', href: '#contatti' },
  ];

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string): void => {
    e.preventDefault();
    if (href !== '#blog') {
      smoothScroll(href);
    }
  };

  return (
    <nav className="nav-menu">
      {menuItems.map((item) => (
        <a
          key={item.href}
          href={item.href}
          onClick={(e) => handleClick(e, item.href)}
        >
          {item.label}
        </a>
      ))}
    </nav>
  );
};

export default NavMenu;



